/**
 * SportIcon — iconos de deportes con volumen y brillo
 * SVGs 80×80 con degradados radiales, reflejo de luz y colores ricos.
 * Look de pelota real, profesional.
 */

// ── FÚTBOL (soccer) ──────────────────────────────────────────────────────────
export function FootballIcon({ size = 24, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <defs>
        <radialGradient id="gcr-socc" cx="35%" cy="30%" r="85%">
          <stop offset="0%" stopColor="#FFFFFF" />
          <stop offset="60%" stopColor="#F4F4F7" />
          <stop offset="100%" stopColor="#CFCFD9" />
        </radialGradient>
        <clipPath id="gcr-socc-clip"><circle cx="40" cy="40" r="33" /></clipPath>
      </defs>
      <circle cx="40" cy="40" r="34" fill="url(#gcr-socc)" />
      <g clipPath="url(#gcr-socc-clip)">
        <polygon points="40,31 47.5,36.5 44.6,45.5 35.4,45.5 32.5,36.5" fill="#1A1A20" />
        <g fill="#1A1A20">
          <polygon points="40,2 47,6 44.5,13 35.5,13 33,6" />
          <polygon points="70,22 74,29 69.5,34.5 63,32 62.5,25" />
          <polygon points="63,62 60,69 52.5,67.5 52,60 57.5,57" />
          <polygon points="17,62 20,69 27.5,67.5 28,60 22.5,57" />
          <polygon points="10,22 6,29 10.5,34.5 17,32 17.5,25" />
        </g>
        <g stroke="#1A1A20" strokeWidth="2.5" strokeLinecap="round">
          <line x1="40" y1="31" x2="40" y2="13" />
          <line x1="47.5" y1="36.5" x2="63" y2="29" />
          <line x1="44.6" y1="45.5" x2="55" y2="59" />
          <line x1="35.4" y1="45.5" x2="25" y2="59" />
          <line x1="32.5" y1="36.5" x2="17" y2="29" />
        </g>
      </g>
      <circle cx="40" cy="40" r="34" fill="none" stroke="#1A1A20" strokeWidth="2.5" />
      <ellipse cx="29" cy="24" rx="10" ry="6" fill="#fff" opacity="0.45" transform="rotate(-25 29 24)" />
    </svg>
  );
}

// ── BALONCESTO ───────────────────────────────────────────────────────────────
export function BasketballIcon({ size = 24, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <defs>
        <radialGradient id="gcr-bask" cx="35%" cy="30%" r="85%">
          <stop offset="0%" stopColor="#FF9A4D" />
          <stop offset="55%" stopColor="#F07B24" />
          <stop offset="100%" stopColor="#BE570D" />
        </radialGradient>
      </defs>
      <circle cx="40" cy="40" r="34" fill="url(#gcr-bask)" />
      <circle cx="40" cy="40" r="34" stroke="#5F2400" strokeWidth="2.5" />
      <g stroke="#4D1D00" strokeWidth="3.5" fill="none" strokeLinecap="round">
        <line x1="40" y1="6" x2="40" y2="74" />
        <line x1="6" y1="40" x2="74" y2="40" />
        <path d="M 14 18 Q 30 40 14 62" />
        <path d="M 66 18 Q 50 40 66 62" />
      </g>
      <ellipse cx="29" cy="24" rx="10" ry="6" fill="#fff" opacity="0.35" transform="rotate(-25 29 24)" />
    </svg>
  );
}

// ── BÉISBOL ──────────────────────────────────────────────────────────────────
export function BaseballIcon({ size = 24, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <defs>
        <radialGradient id="gcr-base" cx="35%" cy="30%" r="85%">
          <stop offset="0%" stopColor="#FFFFFF" />
          <stop offset="60%" stopColor="#FBF8F1" />
          <stop offset="100%" stopColor="#E2DACA" />
        </radialGradient>
      </defs>
      <circle cx="40" cy="40" r="34" fill="url(#gcr-base)" />
      <circle cx="40" cy="40" r="34" stroke="#C9C0AA" strokeWidth="2.5" />
      <g stroke="#D43D2A" strokeWidth="3.5" strokeLinecap="round" strokeDasharray="6 5" fill="none">
        <path d="M 22 12 Q 34 40 22 68" />
        <path d="M 58 12 Q 46 40 58 68" />
      </g>
      <ellipse cx="29" cy="24" rx="10" ry="6" fill="#fff" opacity="0.6" transform="rotate(-25 29 24)" />
    </svg>
  );
}

// ── FÚTBOL AMERICANO ─────────────────────────────────────────────────────────
export function AmericanFootballIcon({ size = 24, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <defs>
        <linearGradient id="gcr-amfb" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#A85F28" />
          <stop offset="55%" stopColor="#8A4B1F" />
          <stop offset="100%" stopColor="#5F2F0D" />
        </linearGradient>
      </defs>
      <g transform="rotate(-30 40 40)">
        <ellipse cx="40" cy="40" rx="32" ry="20" fill="url(#gcr-amfb)" />
        <ellipse cx="40" cy="40" rx="32" ry="20" stroke="#3D1D05" strokeWidth="2.5" />
        <path d="M 18 28 Q 14 40 18 52 L 24 52 Q 20 40 24 28 Z" fill="#F4F4F6" />
        <path d="M 62 28 Q 66 40 62 52 L 56 52 Q 60 40 56 28 Z" fill="#F4F4F6" />
        <line x1="32" y1="40" x2="48" y2="40" stroke="#F4F4F6" strokeWidth="3.5" strokeLinecap="round" />
        <g stroke="#F4F4F6" strokeWidth="2.5" strokeLinecap="round">
          <line x1="35" y1="36" x2="35" y2="44" />
          <line x1="40" y1="36" x2="40" y2="44" />
          <line x1="45" y1="36" x2="45" y2="44" />
        </g>
      </g>
      <ellipse cx="30" cy="26" rx="11" ry="5" fill="#fff" opacity="0.28" transform="rotate(-30 30 26)" />
    </svg>
  );
}

// ── HOCKEY (puck) ────────────────────────────────────────────────────────────
export function HockeyIcon({ size = 24, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <defs>
        <linearGradient id="gcr-puck" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#3D3D47" />
          <stop offset="45%" stopColor="#17171D" />
          <stop offset="100%" stopColor="#000000" />
        </linearGradient>
      </defs>
      <ellipse cx="40" cy="47" rx="30" ry="11" fill="#000" opacity="0.5" />
      <ellipse cx="40" cy="40" rx="30" ry="14" fill="url(#gcr-puck)" />
      <ellipse cx="40" cy="40" rx="30" ry="14" stroke="#4E4E5A" strokeWidth="2" />
      <ellipse cx="40" cy="38" rx="21" ry="8.5" stroke="#5C5C68" strokeWidth="1.5" opacity="0.7" />
      <ellipse cx="30" cy="34" rx="9" ry="3.5" fill="#fff" opacity="0.22" transform="rotate(-8 30 34)" />
    </svg>
  );
}

// ── TENIS ────────────────────────────────────────────────────────────────────
export function TennisIcon({ size = 24, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <defs>
        <radialGradient id="gcr-tenn" cx="35%" cy="30%" r="85%">
          <stop offset="0%" stopColor="#E6FF60" />
          <stop offset="55%" stopColor="#CDEB2D" />
          <stop offset="100%" stopColor="#9BB811" />
        </radialGradient>
      </defs>
      <circle cx="40" cy="40" r="34" fill="url(#gcr-tenn)" />
      <circle cx="40" cy="40" r="34" stroke="#7A9110" strokeWidth="2.5" />
      <g stroke="#FDFDF5" strokeWidth="5" fill="none">
        <path d="M 18 12 Q 34 40 18 68" />
        <path d="M 62 12 Q 46 40 62 68" />
      </g>
      <ellipse cx="29" cy="24" rx="10" ry="6" fill="#fff" opacity="0.5" transform="rotate(-25 29 24)" />
    </svg>
  );
}

// ── Selector por deporte ─────────────────────────────────────────────────────
const MAP = {
  soccer: FootballIcon,
  football: FootballIcon,
  futbol: FootballIcon,
  basketball: BasketballIcon,
  nba: BasketballIcon,
  baseball: BaseballIcon,
  mlb: BaseballIcon,
  beisbol: BaseballIcon,
  american_football: AmericanFootballIcon,
  nfl: AmericanFootballIcon,
  americano: AmericanFootballIcon,
  hockey: HockeyIcon,
  nhl: HockeyIcon,
  tennis: TennisIcon,
  tenis: TennisIcon,
};

export default function SportIcon({ sport = "soccer", size = 24, className = "" }) {
  const key = String(sport || "soccer").toLowerCase().replace(/[-\s]/g, "_");
  const Cmp = MAP[key] || FootballIcon;
  return <Cmp size={size} className={className} />;
}
